import { defineComponent, h } from 'vue';
import { QInnerLoading, QSpinner } from 'quasar';
import BaseComponent from './BaseAgGridMixin.jsx';
import utils from '../../Shared/utils.jsx';

import { AgGridVue } from "ag-grid-vue3";

export default defineComponent({
    name: 'basic-grid',
    mixins: [BaseComponent],
    components: {
        AgGridVue,
        QInnerLoading,
        QSpinner,
    },
    data: () => ({
        aggridref: null,
    }),
    created() {
    },
    computed: {
        dataSource: function () {
            return this.modelfunc ? this.modelfunc : null;
        },
    },
    //Mounted Replaced with preRenderComplete
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);

            //debugger;

            // Access the first child div of the component's root element
            const nestedDiv = this.$refs.aggridref?.$el.children[0];
            if (nestedDiv && nestedDiv.tagName === 'DIV') {
                nestedDiv.classList.add('ag-grid-flex-layout');
            }
        },
        async Refresh(clearSelectedRows) {
            this.internalRefresh(clearSelectedRows);
        },
        getSizeDefaults() {
            // Override in child control if you need to adjust the defaults for size
            // Ex: return { Height: { Mode: "Fill" } }
            return {
                Height: { Mode: "Fill" },
                Width: { Mode: "Fill" }
            };
        },
    },
    props: {},
    render() {
        if (!this.todisplay)
            return null;

        //return (
        //    <div>
        //        <AgGridVue
        //            ref="agGridRef"
        //            class="ag-theme-alpine"
        //            style={{ height: '500px', width: '100%' }}
        //            columnDefs={this.colDefsTest}
        //            rowData={this.rowDataTest}
        //        />
        //    </div>
        //);

        const style = {
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            minHeight: "400px",
            padding: '8px',
            ...this.sizeStyle,
        };

        return (
            <div
                key={this.unique_id + '_main'}
                v-show={this.isvisible}
                class={{ 'c-BasicGrid': true, [`c-name-${this.name || 'unnamed'}`]: true, 'ag-theme-alpine': true }}
                style={style}
                ref="outerdiv"
            >
                <QInnerLoading showing={this.loading}>
                    <QSpinner
                        ref="progresscircular"
                        color="primary"
                        size="64px"
                    />
                </QInnerLoading>

                {this.getGridHeaders()}
                <AgGridVue
                    key={this.unique_id}
                    ref="agGridRef"
                    xref={(el) => this.setref(el)}
                    style={{ display: 'flex', flexDirection: 'column', flexGrow: '1' }}
                    rowData={this.dataSource}
                    columnDefs={this.agColumnDefs}
                    columnMenu="new"
                    rowSelection={this.getRowSelectionConfig()}
                    enableCellTextSelection={true}
                    ensureDomOrder={true}
                    quickFilterText={this.searchText}
                    suppressScrollOnNewData={true}
                    suppressCellSelection={true}
                    suppressDragLeaveHidesColumns={true}
                    pagination={this.pagination}
                    paginationAutoPageSize={this.pagination}
                    getRowClass={this.getRowClass}
                    maintainColumnOrder={true}

                    onGridReady={this.onGridReady}
                    onFirstDataRendered={(e) => this.onFirstDataRendered(e)}
                    onSelectionChanged={(e) => this.rowSelectionChanged(e)}
                    onFilterChanged={this.columnFilterChanged}
                    onSortChanged={this.onSaveGridSortState}
                    onColumnVisible={this.onSaveGridColumnState}
                    onColumnPinned={this.onSaveGridColumnState}
                    onColumnResized={this.onSaveGridColumnState}
                    onColumnMoved={this.onSaveGridColumnState}
                    onColumnRowGroupChanged={this.onSaveGridColumnState}
                >
                </AgGridVue>
            </div>
        );
    }
});